import { z } from 'zod';

export const dearFamilySchema = {
  required: z.object({
    letter: z.string().min(1, 'Letter is required'),
  }),
  optional: z.object({
    letter: z.string().optional(),
  }),
};

export type DearFamilyFormValues = z.infer<(typeof dearFamilySchema)['required']> | z.infer<(typeof dearFamilySchema)['optional']>;

export const defaultValues: DearFamilyFormValues = {
  letter: '',
};
